import React from "react";
import { TextInput } from "web-ui/juicy";
import { LegacyButton as Button } from "web-ui/legacy";

/* eslint-disable react/jsx-no-literals */

export const AddTextDialog = ({
  isVisible,
  onCancel,
  onAddPhoneme,
  onAddWord,
}: {
  isVisible: boolean;
  onCancel: () => void;
  onAddPhoneme: (newText: string | undefined) => void;
  onAddWord: (newText: string | undefined) => void;
}) => {
  const [text, setText] = React.useState<string>();

  return isVisible ? (
    <div>
      <TextInput
        autoFocus={true}
        onChange={e => setText(e.target.value)}
        placeholder="New text"
        type="text"
        value={text ?? ""}
      />
      <Button
        color="snow"
        onClick={() => {
          onCancel();
          setText(undefined);
        }}
        variant="solid"
      >
        Cancel
      </Button>
      <Button
        color="owl"
        onClick={() => {
          onAddPhoneme(text);
          setText(undefined);
        }}
        variant="solid"
      >
        Add Phoneme
      </Button>
      <Button
        color="macaw"
        onClick={() => {
          onAddWord(text);
          setText(undefined);
        }}
        variant="solid"
      >
        Add Word
      </Button>
    </div>
  ) : null;
};
